import React from 'react';
import classNameBind from 'classnames/bind';
import Header from '../Header';
import styles from './Card.module.css';
import CardSection from './components/CardSection';
import CardAccordion from './components/CardAccordion';

const bindClasses = classNameBind.bind(styles);

const Card = ({
  children,
  title,
  dataId,
}) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id={dataId}
  >
    {title && <Header>{title}</Header>}
    <div className={bindClasses('sections')}>
      {children}
    </div>
  </div>
);

Card.defaultProps = {
  children: null,
  title: null,
  dataId: 'Card',
};

Card.Accordion = CardAccordion;
Card.Section = CardSection;

export default Card;
